import React from 'react';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setBreadcrumb } from '../../../actions/admin/breadcrumb';
import { breadcrumbSetSelector } from '../../../selectors/admin/breadcrumb';

function BreadcrumbWrapper(WrappedComponent, breadcrumb) {
    return class extends React.Component {
        _setBreadcrumb() {
            const breadCrumbSettings = breadcrumb(this.props);
            if (!this.props.breadcrumbSet) {
                this.props.setBreadcrumb(breadCrumbSettings, this.props.match.params);
            }
        }
        componentDidMount() {
            this._setBreadcrumb();
        }
        componentDidUpdate() {
            this._setBreadcrumb();
        }
        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
}

const mapStateToProps = state => ({
    breadcrumbSet: breadcrumbSetSelector(state)
});
const mapDispatchToProps = dispatch => bindActionCreators({ setBreadcrumb }, dispatch);

export const withBreadcrumb = compose(connect(mapStateToProps, mapDispatchToProps), BreadcrumbWrapper);
